import "./CSS/Header.css";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import redlogo from "../COMPONENTS/IMAGES/sapra_logo-removebg-preview 2 (1).png";
import logo from "../COMPONENTS/IMAGES/Frame 197.png";
import { API_BASE, FILE_BASE } from "../config";
import axios from "axios";
import { GoogleLogin } from "@react-oauth/google";



export default function PinkHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const [active, setActive] = useState("");
  const [step, setStep] = useState(1);
  const [open, setOpen] = useState(false);

  const [index, setIndex] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!sessionStorage.getItem("token")
  );
  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [slides, setSlides] = useState([]);

  const handleUserClick = () => {
    console.log(sessionStorage.getItem("token"));

    const token = sessionStorage.getItem("token");

    if (token) {
      navigate("/orders");
    } else {
      setOpen(true);
    }
  };

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [registerData, setRegisterData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",

    phoneNumber: "",
    city: "",
    state: "",
    address: "",
    pincode: ""
  });

  const handleLogin = async () => {
    try {

      const response = await axios.post(
        `${API_BASE}/auth/login`,
        {
          email: loginData.email,
          password: loginData.password,
        }
      );

      console.log(response.data);

      // GET TOKEN FROM RESPONSE
      const token = response.data.token;

      // SAVE TOKEN
      sessionStorage.setItem("token", token);

      // DECODE JWT
      const payload = JSON.parse(
        atob(token.split(".")[1])
      );

      console.log(payload);

      // CREATE CUSTOMER OBJECT
      const customer = {
        id: payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ],
        email:
          payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
          ],
        name:
          payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
          ],
      };

      console.log(customer);

      // SAVE CUSTOMER
      sessionStorage.setItem(
        "customer",
        JSON.stringify(customer)
      );

      // SAVE EXPIRY
      const expiry =
        new Date().getTime() + 24 * 60 * 60 * 1000;

      sessionStorage.setItem(
        "tokenExpiry",
        expiry
      );

      setIsLoggedIn(true);

      setOpen(false);

      navigate("/orders");

    } catch (error) {

      console.log(error);

      alert(
        error.response?.data?.message ||
        "Login failed"
      );
    }
  };


  const handleRegister = async () => {
    try {

      if (
        registerData.password !==
        registerData.confirmPassword
      ) {
        alert("Passwords do not match");
        return;
      }

      console.log(registerData);

      const response = await axios.post(
        `${API_BASE}/auth/register`,
        {
          name: registerData.name,
          email: registerData.email,
          password: registerData.password,

          // SEND EMPTY VALUES
          phoneNumber: "",
          city: "",
          state: "",
          address: "",
          pincode: ""
        }
      );

      console.log(response.data);

      // GET TOKEN
      const token = response.data.token;

      // GET USER
      const customer = response.data.user;

      // SAVE TOKEN
      sessionStorage.setItem(
        "token",
        token
      );

      // SAVE CUSTOMER
      sessionStorage.setItem(
        "customer",
        JSON.stringify(customer)
      );

      // SAVE EXPIRY
      const expiry =
        new Date().getTime() +
        24 * 60 * 60 * 1000;

      sessionStorage.setItem(
        "tokenExpiry",
        expiry
      );

      setIsLoggedIn(true);

      setOpen(false);

      navigate("/orders");

    } catch (error) {

      console.log(error);

      console.log(error.response?.data);

      alert(
        error.response?.data?.message ||
        error.response?.data ||
        "Registration failed"
      );
    }
  };


  const handleGoogleSuccess = async (credentialResponse) => {
    try {

      const response = await axios.post(
        `${API_BASE}/auth/google-login`,
        {
          idToken: credentialResponse.credential,
        }
      );


      // GET TOKEN FROM RESPONSE
      const token = response.data.token;

      // SAVE TOKEN
      sessionStorage.setItem("token", token);

      // DECODE JWT
      const payload = JSON.parse(
        atob(token.split(".")[1])
      );


      // CREATE CUSTOMER OBJECT
      const customer = {
        id: payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ],
        email:
          payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
          ],
        name:
          payload[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
          ],
      };


      // SAVE CUSTOMER
      sessionStorage.setItem(
        "customer",
        JSON.stringify(customer)
      );

      // SAVE EXPIRY
      const expiry =
        new Date().getTime() + 24 * 60 * 60 * 1000;

      sessionStorage.setItem(
        "tokenExpiry",
        expiry
      );

      setIsLoggedIn(true);

      setOpen(false);

      navigate("/orders");

    } catch (error) {

      console.log(error);

      alert("Google Login Failed");
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const expiry = sessionStorage.getItem("tokenExpiry");

    if (token && expiry) {

      if (new Date().getTime() > Number(expiry)) {

        sessionStorage.clear();

        setIsLoggedIn(false);

      } else {
        setIsLoggedIn(true);
      }
    }
  }, []);

  return (
    <header className="pink-navbar">
      {/* <nav className="pink-nav-left">
  <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>
    Home
  </NavLink>

  <NavLink to="/shop" className={({ isActive }) => isActive ? "active" : ""}>
    Shop
  </NavLink>

  <NavLink to="/about" className={({ isActive }) => isActive ? "active" : ""}>
    About
  </NavLink>

  <NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>
    Contact
  </NavLink>
</nav> */}
      <nav className={`pink-nav-left ${menuOpen ? "active" : ""}`}>
        <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
        <NavLink to="/shop" onClick={() => setMenuOpen(false)}>Shop</NavLink>
        <NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink>
        <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink>
      </nav>

      {/* HAMBURGER */}
      <div
        className="pink-hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="pink-logo">
        <img src={logo} alt="SaPra Logo" />
      </div>

      <div className="pink-nav-right">
        {/* Search */}
        {/* <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
  <path d="M22.8667 24.5L15.5167 17.15C14.9333 17.6167 14.2625 17.9861 13.5042 18.2583C12.7458 18.5306 11.9389 18.6667 11.0833 18.6667C8.96389 18.6667 7.17014 17.9326 5.70208 16.4646C4.23403 14.9965 3.5 13.2028 3.5 11.0833C3.5 8.96389 4.23403 7.17014 5.70208 5.70208C7.17014 4.23403 8.96389 3.5 11.0833 3.5C13.2028 3.5 14.9965 4.23403 16.4646 5.70208C17.9326 7.17014 18.6667 8.96389 18.6667 11.0833C18.6667 11.9389 18.5306 12.7458 18.2583 13.5042C17.9861 14.2625 17.6167 14.9333 17.15 15.5167L24.5 22.8667L22.8667 24.5ZM11.0833 16.3333C12.5417 16.3333 13.7812 15.8229 14.8021 14.8021C15.8229 13.7812 16.3333 12.5417 16.3333 11.0833C16.3333 9.625 15.8229 8.38542 14.8021 7.36458C13.7812 6.34375 12.5417 5.83333 11.0833 5.83333C9.625 5.83333 8.38542 6.34375 7.36458 7.36458C6.34375 8.38542 5.83333 9.625 5.83333 11.0833C5.83333 12.5417 6.34375 13.7812 7.36458 14.8021C8.38542 15.8229 9.625 16.3333 11.0833 16.3333Z" fill="black"/>
</svg>
        </span> */}

        {/* Cart */}
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" onClick={() => navigate("/cart")} width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M8.16675 25.6667C7.52508 25.6667 6.97578 25.4382 6.51883 24.9813C6.06189 24.5243 5.83341 23.975 5.83341 23.3333C5.83341 22.6917 6.06189 22.1424 6.51883 21.6854C6.97578 21.2285 7.52508 21 8.16675 21C8.80841 21 9.35772 21.2285 9.81466 21.6854C10.2716 22.1424 10.5001 22.6917 10.5001 23.3333C10.5001 23.975 10.2716 24.5243 9.81466 24.9813C9.35772 25.4382 8.80841 25.6667 8.16675 25.6667ZM19.8334 25.6667C19.1917 25.6667 18.6424 25.4382 18.1855 24.9813C17.7286 24.5243 17.5001 23.975 17.5001 23.3333C17.5001 22.6917 17.7286 22.1424 18.1855 21.6854C18.6424 21.2285 19.1917 21 19.8334 21C20.4751 21 21.0244 21.2285 21.4813 21.6854C21.9383 22.1424 22.1667 22.6917 22.1667 23.3333C22.1667 23.975 21.9383 24.5243 21.4813 24.9813C21.0244 25.4382 20.4751 25.6667 19.8334 25.6667ZM7.17508 7L9.97508 12.8333H18.1417L21.3501 7H7.17508ZM6.06675 4.66667H23.2751C23.7223 4.66667 24.0626 4.86597 24.2959 5.26459C24.5292 5.6632 24.539 6.06667 24.3251 6.475L20.1834 13.9417C19.9695 14.3306 19.6827 14.6319 19.323 14.8458C18.9633 15.0597 18.5695 15.1667 18.1417 15.1667H9.45008L8.16675 17.5H22.1667V19.8333H8.16675C7.29175 19.8333 6.63064 19.4493 6.18341 18.6813C5.73619 17.9132 5.71675 17.15 6.12508 16.3917L7.70008 13.5333L3.50008 4.66667H1.16675V2.33334H4.95841L6.06675 4.66667Z" fill="black" />
          </svg>
        </span>

        {/* Profile */}
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" onClick={handleUserClick} width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M14.0001 14C12.7167 14 11.6181 13.5431 10.7042 12.6292C9.79036 11.7153 9.33341 10.6167 9.33341 9.33333C9.33341 8.05 9.79036 6.95139 10.7042 6.0375C11.6181 5.12361 12.7167 4.66666 14.0001 4.66666C15.2834 4.66666 16.382 5.12361 17.2959 6.0375C18.2098 6.95139 18.6667 8.05 18.6667 9.33333C18.6667 10.6167 18.2098 11.7153 17.2959 12.6292C16.382 13.5431 15.2834 14 14.0001 14ZM4.66675 23.3333V20.0667C4.66675 19.4056 4.83689 18.7979 5.17716 18.2437C5.51744 17.6896 5.96953 17.2667 6.53341 16.975C7.73897 16.3722 8.96397 15.9201 10.2084 15.6187C11.4529 15.3174 12.7167 15.1667 14.0001 15.1667C15.2834 15.1667 16.5473 15.3174 17.7917 15.6187C19.0362 15.9201 20.2612 16.3722 21.4667 16.975C22.0306 17.2667 22.4827 17.6896 22.823 18.2437C23.1633 18.7979 23.3334 19.4056 23.3334 20.0667V23.3333H4.66675ZM7.00008 21H21.0001V20.0667C21.0001 19.8528 20.9466 19.6583 20.8397 19.4833C20.7327 19.3083 20.5917 19.1722 20.4167 19.075C19.3667 18.55 18.307 18.1562 17.2376 17.8937C16.1681 17.6312 15.089 17.5 14.0001 17.5C12.9112 17.5 11.832 17.6312 10.7626 17.8937C9.69314 18.1562 8.63341 18.55 7.58341 19.075C7.40841 19.1722 7.26744 19.3083 7.1605 19.4833C7.05355 19.6583 7.00008 19.8528 7.00008 20.0667V21ZM14.0001 11.6667C14.6417 11.6667 15.1911 11.4382 15.648 10.9812C16.1049 10.5243 16.3334 9.975 16.3334 9.33333C16.3334 8.69166 16.1049 8.14236 15.648 7.68541C15.1911 7.22847 14.6417 7 14.0001 7C13.3584 7 12.8091 7.22847 12.3522 7.68541C11.8952 8.14236 11.6667 8.69166 11.6667 9.33333C11.6667 9.975 11.8952 10.5243 12.3522 10.9812C12.8091 11.4382 13.3584 11.6667 14.0001 11.6667Z" fill="black" />
          </svg>

        </span>
      </div>

      {open && (
        <div className="popup-overlay">
          <div className="popup-box">
            <span
              className="close-btn"
              onClick={() => {
                setOpen(false);
                setStep(1);
              }}
            >
              ✕
            </span>

            {/* LOGO */}
            <img src={redlogo} alt="SaPra Logo" className="logo-imgi" />
            <p className="sub-logo">House of Élàn</p>

            {step === 1 ? (
              <>
                <h2>Sign in</h2>
                <p className="subtitle-red">Welcome Back to the World of SaPra</p>
                <label>Email</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={loginData.email}
                  onChange={(e) =>
                    setLoginData({
                      ...loginData,
                      email: e.target.value,
                    })
                  }
                />

                <div className="password-field">
                  <label>Password</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your password"
                    value={loginData.password}
                    onChange={(e) =>
                      setLoginData({
                        ...loginData,
                        password: e.target.value,
                      })
                    }
                  />

                  <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7Zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" fill="#666" />
                        <circle cx="12" cy="12" r="2.5" fill="#666" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19.8822 4.88134L19.1463 4.14539C18.9383 3.9374 18.5543 3.96941 18.3143 4.25736L15.7541 6.80132C14.602 6.30538 13.3382 6.06538 12.0101 6.06538C8.05798 6.08132 4.6342 8.38529 2.98608 11.6975C2.89006 11.9055 2.89006 12.1614 2.98608 12.3374C3.75402 13.9054 4.90609 15.2015 6.34609 16.1774L4.2501 18.3054C4.0101 18.5454 3.97809 18.9293 4.13813 19.1374L4.87408 19.8733C5.08207 20.0813 5.46606 20.0493 5.70606 19.7613L19.754 5.71345C20.058 5.47358 20.09 5.08962 19.882 4.88161L19.8822 4.88134ZM12.8581 9.71322C12.5861 9.6492 12.2981 9.56925 12.0261 9.56925C10.6661 9.56925 9.57818 10.6573 9.57818 12.0172C9.57818 12.2892 9.64219 12.5771 9.72215 12.8492L8.65003 13.9052C8.33008 13.3452 8.15409 12.7211 8.15409 12.0172C8.15409 9.88924 9.86611 8.17722 11.9941 8.17722C12.6982 8.17722 13.3221 8.3532 13.8821 8.67316L12.8581 9.71322Z" fill="#666666" fill-opacity="0.8" />
                        <path d="M21.0342 11.6974C20.4742 10.5774 19.7381 9.56945 18.8262 8.75342L15.8502 11.6974V12.0174C15.8502 14.1454 14.1382 15.8574 12.0102 15.8574H11.6902L9.80225 17.7454C10.5063 17.8893 11.2422 17.9854 11.9623 17.9854C15.9144 17.9854 19.3382 15.6814 20.9863 12.3532C21.1302 12.1292 21.1302 11.9053 21.0342 11.6973L21.0342 11.6974Z" fill="#666666" fill-opacity="0.8" />
                      </svg>
                    )}
                  </span>
                </div>
                <button
                  onClick={handleLogin}
                  className="continue-btn"
                >
                  Log in
                </button>

                <p className="terms">
                  Don’t have an account? <span style={{ cursor: "pointer" }} onClick={() => setStep(2)}
                  >Create New Account</span>
                </p>
              </>
            ) : (
              <>
                <h2>Sign up</h2>
                <p className="subtitle-red">Begin Your Journey with SaPra</p>
                <label>Email</label>
                <input
                  type="text"
                  placeholder="Enter your email"
                  value={registerData.email}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      email: e.target.value,
                    })
                  }
                />

                <label>Username</label>
                <input
                  type="text"
                  placeholder="Enter your username"
                  value={registerData.name}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      name: e.target.value,
                    })
                  }
                />

                <div className="password-field">
                  <label> New Password</label>
                  <input
                    type={showNewPassword ? "text" : "password"}
                    placeholder="Enter your password"
                    value={registerData.password}
                    onChange={(e) =>
                      setRegisterData({
                        ...registerData,
                        password: e.target.value,
                      })
                    }
                  />

                  <span className="eye-icon" onClick={() => setShowNewPassword(!showNewPassword)}>
                    {showNewPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7Zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" fill="#666" />
                        <circle cx="12" cy="12" r="2.5" fill="#666" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19.8822 4.88134L19.1463 4.14539C18.9383 3.9374 18.5543 3.96941 18.3143 4.25736L15.7541 6.80132C14.602 6.30538 13.3382 6.06538 12.0101 6.06538C8.05798 6.08132 4.6342 8.38529 2.98608 11.6975C2.89006 11.9055 2.89006 12.1614 2.98608 12.3374C3.75402 13.9054 4.90609 15.2015 6.34609 16.1774L4.2501 18.3054C4.0101 18.5454 3.97809 18.9293 4.13813 19.1374L4.87408 19.8733C5.08207 20.0813 5.46606 20.0493 5.70606 19.7613L19.754 5.71345C20.058 5.47358 20.09 5.08962 19.882 4.88161L19.8822 4.88134ZM12.8581 9.71322C12.5861 9.6492 12.2981 9.56925 12.0261 9.56925C10.6661 9.56925 9.57818 10.6573 9.57818 12.0172C9.57818 12.2892 9.64219 12.5771 9.72215 12.8492L8.65003 13.9052C8.33008 13.3452 8.15409 12.7211 8.15409 12.0172C8.15409 9.88924 9.86611 8.17722 11.9941 8.17722C12.6982 8.17722 13.3221 8.3532 13.8821 8.67316L12.8581 9.71322Z" fill="#666666" fill-opacity="0.8" />
                        <path d="M21.0342 11.6974C20.4742 10.5774 19.7381 9.56945 18.8262 8.75342L15.8502 11.6974V12.0174C15.8502 14.1454 14.1382 15.8574 12.0102 15.8574H11.6902L9.80225 17.7454C10.5063 17.8893 11.2422 17.9854 11.9623 17.9854C15.9144 17.9854 19.3382 15.6814 20.9863 12.3532C21.1302 12.1292 21.1302 11.9053 21.0342 11.6973L21.0342 11.6974Z" fill="#666666" fill-opacity="0.8" />
                      </svg>
                    )}
                  </span>
                </div>
                <div className="password-field">
                  <label> Confirm Password</label>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm password"
                    value={registerData.confirmPassword}
                    onChange={(e) =>
                      setRegisterData({
                        ...registerData,
                        confirmPassword: e.target.value,
                      })
                    }
                  />

                  <span className="eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                    {showConfirmPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7Zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" fill="#666" />
                        <circle cx="12" cy="12" r="2.5" fill="#666" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19.8822 4.88134L19.1463 4.14539C18.9383 3.9374 18.5543 3.96941 18.3143 4.25736L15.7541 6.80132C14.602 6.30538 13.3382 6.06538 12.0101 6.06538C8.05798 6.08132 4.6342 8.38529 2.98608 11.6975C2.89006 11.9055 2.89006 12.1614 2.98608 12.3374C3.75402 13.9054 4.90609 15.2015 6.34609 16.1774L4.2501 18.3054C4.0101 18.5454 3.97809 18.9293 4.13813 19.1374L4.87408 19.8733C5.08207 20.0813 5.46606 20.0493 5.70606 19.7613L19.754 5.71345C20.058 5.47358 20.09 5.08962 19.882 4.88161L19.8822 4.88134ZM12.8581 9.71322C12.5861 9.6492 12.2981 9.56925 12.0261 9.56925C10.6661 9.56925 9.57818 10.6573 9.57818 12.0172C9.57818 12.2892 9.64219 12.5771 9.72215 12.8492L8.65003 13.9052C8.33008 13.3452 8.15409 12.7211 8.15409 12.0172C8.15409 9.88924 9.86611 8.17722 11.9941 8.17722C12.6982 8.17722 13.3221 8.3532 13.8821 8.67316L12.8581 9.71322Z" fill="#666666" fill-opacity="0.8" />
                        <path d="M21.0342 11.6974C20.4742 10.5774 19.7381 9.56945 18.8262 8.75342L15.8502 11.6974V12.0174C15.8502 14.1454 14.1382 15.8574 12.0102 15.8574H11.6902L9.80225 17.7454C10.5063 17.8893 11.2422 17.9854 11.9623 17.9854C15.9144 17.9854 19.3382 15.6814 20.9863 12.3532C21.1302 12.1292 21.1302 11.9053 21.0342 11.6973L21.0342 11.6974Z" fill="#666666" fill-opacity="0.8" />
                      </svg>
                    )}
                  </span>
                </div>

                <button
                  className="continue-btn"
                  onClick={handleRegister}
                >
                  Sign Up
                </button>

                <p className="terms">
                  If Already have an account?  <span style={{ cursor: "pointer" }} onClick={() => setStep(1)}
                  >Log in  </span>
                </p>
              </>
            )}

            <div className="dividerr">OR</div>


            <div className="google-login-wrapper">
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => {
                  alert("Google Login Failed");
                }}
              />
            </div>

          </div>
        </div>
      )}
    </header>
  );
}